/* eslint-disable @typescript-eslint/camelcase */
import React, { useState, useEffect } from 'react';
import capitalise from '../../../../utils/capitalise';
import querystring from 'query-string';
import { useMediaQuery } from 'react-responsive';
import { trackAirportTemplateEvent } from '../../../../utils/omnitureTracking';
import { AppContextConsumer } from '../../../../AppContext';
import { setDateAsDatePlusN } from '../../../../utils/timeUtils';
import BPG from '../../../../components/BPG/BPG';
import { CASE_CAB_CARD } from '../../../../constants/omniture';
import { isMobile, isWebView } from '../../../../utils/commonUtils';

type AirportCabListProps = {
  data: any;
  cityName: string;
  airportName: string;
};

export default function AirportCabList({
  data,
  cityName,
  airportName
}: AirportCabListProps) {
  const [selectedCabType, handleCabSelect] = useState<null | string>(
    'airport_drop_cab_list'
  );

  useEffect(() => {
    handleCabSelect('airport_drop_cab_list');
  }, []);

  const cabTypes = [
    {
      name: 'Airport Drop',
      type: 'airport_drop_cab_list'
    },
    {
      name: 'Airport Pickup',
      type: 'airport_pickup_cab_list'
    }
  ];
  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)'
  });

  const isMobileDeviceWidthForSeatAndBagInfo = useMediaQuery({
    query: '(max-device-width: 420px)'
  });
  const trackClick = eventString => {
    trackAirportTemplateEvent(eventString);
  };
  const removeHypens = string => string.replace(/_/g, ' ');

  const handleCabSelectWithOmniture = (eventString, cabType) => {
    trackClick(eventString);
    handleCabSelect(cabType);
  };
  const { airport_drop_redirection_url, airport_pickup_redirection_url } = data;
  const query = querystring.parseUrl(airport_drop_redirection_url).query;
  const cityCode = query['fromCity'];
  const airportCode = query['toCity'];
  const computeRedirectionUrl = () => {
    let redirectionUrl;
    if (selectedCabType === 'airport_drop_cab_list') {
      redirectionUrl =
        typeof window !== 'undefined' && isWebView()
          ? `mmyt://react/?page=cabsListing&deeplink=true&to=${airportCode}&from=${cityCode}&tripType=AT&startDate=17-07-2020`
          : airport_drop_redirection_url;
    } else {
      redirectionUrl =
        typeof window !== 'undefined' && isWebView()
          ? `mmyt://react/?page=cabsListing&deeplink=true&to=${cityCode}&from=${airportCode}&tripType=AT&startDate=17-07-2020`
          : airport_pickup_redirection_url;
    }
    return redirectionUrl;
  };
  return (
    <AppContextConsumer>
      {({ omniUrlArgs }) => {
        const getRedirectionUrl = (url: string) => {
          return `${setDateAsDatePlusN(url, 1)}&${omniUrlArgs}${CASE_CAB_CARD}`;
        };

        return (
          <div className="cabTypeWrap">
            <div className="tapWrap">
              <p className="tabTypeTitleSmall">
                Select trip type to update price, included kms & extra fare
              </p>
              <div className="tabTypeTitle">
                <p className="headingText">Select trip type</p>
                <p className="subHeadingText">
                  To update price, included kms & extra fare
                </p>
              </div>
              <ul className="cabTap">
                {cabTypes.map(cabType => (
                  <li
                    onClick={() =>
                      handleCabSelectWithOmniture(
                        `Cab_SEO_${cabType.type}_Select`,
                        cabType.type
                      )
                    }
                    key={cabType.type}
                    className={selectedCabType === cabType.type ? 'active' : ''}
                  >
                    <span className="activeCheck"></span>
                    <span className="cabTabtext">{cabType.name}</span>
                    <span className="circleOuter">
                      <span className="circleInner"></span>
                    </span>
                  </li>
                ))}
              </ul>
            </div>
            <div style={{ borderTop: 'none' }} className="cabTypeDetails">
              {/*TODO handle data[selectedCabType] not available*/}
              {selectedCabType &&
                data[selectedCabType].map((item, index) => {
                  return isMobile() ? (
                    <>
                      <div
                        key={index}
                        className={
                          index === 0 ? 'cabTypeRow noBdr' : 'cabTypeRow'
                        }
                      >
                        <a
                          onClick={() =>
                            trackClick(
                              `Cab_SEO_${selectedCabType}_${item.type}_Select`
                            )
                          }
                          href={getRedirectionUrl(`${computeRedirectionUrl()}`)}
                        >
                          <div className="cabTypeCol">
                            <div className="makeFlex column">
                              <span className="carImgWrap">
                                <img
                                  className="lazyload"
                                  data-src={item.image}
                                  alt="carImg"
                                />
                              </span>
                              <div>
                                <p className="cabTypeRoute">
                                  {item.vehicle_model}
                                </p>
                                {item.type !== item.vehicle_model ? (
                                  <p className="cabTimeDis">
                                    {capitalise(removeHypens(item.type))}
                                  </p>
                                ) : null}
                              </div>
                              <div
                                className={`${
                                  isMobileDeviceWidthForSeatAndBagInfo
                                    ? ``
                                    : `makeFlex`
                                } font11 hrtlCenter paddingT5 blackText`}
                              >
                                <span
                                  className={`makeFlex hrtlCenter appendRight5 ${
                                    isMobileDeviceWidthForSeatAndBagInfo
                                      ? `appendBottom2`
                                      : ``
                                  }`}
                                >
                                  {`${item.utilities[1][0]} Seats ${
                                    isMobileDeviceWidthForSeatAndBagInfo
                                      ? ``
                                      : `|`
                                  }`}
                                </span>
                                <span
                                  className={`makeFlex hrtlCenter appendRight5 ${
                                    isMobileDeviceWidthForSeatAndBagInfo
                                      ? `appendBottom2`
                                      : ``
                                  }`}
                                >
                                  {`${item.utilities[2][0]} Bag(s) ${
                                    isMobileDeviceWidthForSeatAndBagInfo
                                      ? ``
                                      : `|`
                                  }`}
                                </span>
                                {item.utilities.includes('AC') && <>AC</>}
                              </div>
                            </div>
                          </div>
                          <div className="cabTypeCol">
                            <p className="cabTypeIncDis">
                              {item.included_kms} kms included
                            </p>
                            {item.per_km_charge > 0 ? (
                              <p className="cabTypeFare">
                                Extra fare ₹{item.per_km_charge}/km after{' '}
                                {item.included_kms} kms
                              </p>
                            ) : null}
                          </div>
                          <div className="cabTypeCol">
                            {item.strike_off_amount ? (
                              <div className="pushRight appendBottom3">
                                <p className="strikeOffPrice">
                                  ₹{item.strike_off_amount}
                                </p>
                              </div>
                            ) : null}
                            <p className="cabTypePrice">₹{item.total_amount}</p>
                            <p className="cabTypeOnwards paddingT5">
                              {item?.tolls_and_taxes_text}
                            </p>
                          </div>
                          <div className="cabTypeCol"></div>
                        </a>
                      </div>
                      {item.best_price_guarantee_details ? (
                        <BPG
                          bpgInfo={item.best_price_guarantee_details}
                          isMobileDevice={true}
                          fromCity={
                            selectedCabType === 'airport_drop_cab_list'
                              ? cityName
                              : airportName
                          }
                          toCity={
                            selectedCabType === 'airport_drop_cab_list'
                              ? airportName
                              : cityName
                          }
                        />
                      ) : null}
                    </>
                  ) : (
                    <>
                      <div
                        key={index}
                        className={
                          index === 0 ? 'cabTypeRow noBdr' : 'cabTypeRow'
                        }
                      >
                        <div className="cabTypeCol">
                          <div className="makeFlex">
                            <span className="carImgWrap">
                              <img
                                className="lazyload"
                                data-src={item.image}
                                alt="carImg"
                                height={53}
                                width={70}
                              />
                            </span>
                            <div>
                              <span className="cabTypeRoute appendRight5">
                                {item.vehicle_model}
                              </span>
                              {item.type !== item.vehicle_model ? (
                                <span className="cabTimeDis">
                                  {capitalise(removeHypens(item.type))}
                                </span>
                              ) : null}
                              <div className="makeFlex font12 hrtlCenter paddingT5">
                                <span className="makeFlex hrtlCenter appendRight10">
                                  <span className="seatIocn appendRight5 cabSeoSprite"></span>{' '}
                                  {item.utilities[1][0]} Seats
                                </span>
                                <span className="makeFlex hrtlCenter appendRight10">
                                  <span className="bagsIocn appendRight5 cabSeoSprite"></span>{' '}
                                  {item.utilities[2][0]} Luggage Bags
                                </span>
                                {item.utilities.includes('AC') && (
                                  <span className="makeFlex hrtlCenter appendRight10">
                                    <span className="acIocn appendRight5 cabSeoSprite"></span>{' '}
                                    &nbsp;AC
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="cabTypeCol">
                          <p className="cabTypeIncDis">
                            {item.included_kms} kms included
                          </p>
                          {item.per_km_charge > 0 ? (
                            <p className="cabTypeFare">
                              Extra fare ₹{item.per_km_charge}/km after{' '}
                              {item.included_kms} kms
                            </p>
                          ) : null}
                        </div>
                        <div className="cabTypeCol flexOne">
                          <p className="cabTypePrice">
                            ₹{item.total_amount}
                            {item.strike_off_amount ? (
                              <span className="appendLeft5 strikeOffPrice">
                                ₹{item.strike_off_amount}
                              </span>
                            ) : null}
                          </p>
                          <p className="cabTypeOnwards paddingT5">
                            {item?.tolls_and_taxes_text}
                          </p>
                        </div>
                        <div className="cabTypeCol ">
                          <a
                            className="viewCabBtn"
                            onClick={() =>
                              trackClick(
                                `Cab_SEO_${selectedCabType}_${item.type}_Select`
                              )
                            }
                            href={getRedirectionUrl(
                              `${computeRedirectionUrl()}`
                            )}
                          >
                            {' '}
                            VIEW CABS
                          </a>
                        </div>
                      </div>
                      {item.best_price_guarantee_details ? (
                        <BPG
                          bpgInfo={item.best_price_guarantee_details}
                          isMobileDevice={false}
                          fromCity={
                            selectedCabType === 'airport_drop_cab_list'
                              ? cityName
                              : airportName
                          }
                          toCity={
                            selectedCabType === 'airport_drop_cab_list'
                              ? airportName
                              : cityName
                          }
                        />
                      ) : null}
                    </>
                  );
                })}
            </div>
          </div>
        );
      }}
    </AppContextConsumer>
  );
}
